import './theme/common.scss';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import getAppConfig from './getAppConfig';
import getBodyPluginApp from './bodyPlugins/csrEntry.js';
import util from './common/util';
import initCookiesClient from './init/initCookiesClient';
import initCookies from './init/initCookies';
import { getOtherData, getGlobalData, getPageData } from './init/data/getDataFromJsp';
import handlerData, { generateThemeRootVar } from './init/data/handlerData';
import getPlatform from './isomorphic/client';
import getContainer from './init/getContainer';
import globalization from './globalization';
import createTerminology from './common/terminology';
import googleTranslateAutoPage from './common/translate/googleTranslatePlugin/auto-page';
import { getCurrentLanguage } from './globalization/tool';

import plugin from './plugins';
import Router from './common/router';
import initCookieAuthority from './components/cookieAuthority';
//import { init as initRequirePhone } from './components/require-phone';
import initCopyRight from './components/copyRight';
import initGotoTop from './components/gotoTop';
import initSidebar from './components/mdSidebar';
import createRunner from './customCode';
import handlePopup from './handlePopup';
import checkTimeoutSession from './common/timeoutSession';
import otherProcessing from './otherProcessing';
import chat from './components/chat';
import termOfUse from './components/term-of-use';
import vowPassword from './components/vow-password';

import { createDownloadPlugin } from './components/download-closely/pop';
import { sanitizeVowSoldFields, isVowVerified } from './common/vow-sanitizer';
import './loadFont';
import './common/rendebug';
import gaConversion from './common/ga-conversion';
import trackBingAd from './common/track/bing-ad';
import Track from '@/common/track';
import adwerx from '@/common/track/adwerx';
import fub from '@/common/track/fub';
import './fastClick';



function checkRedirectUrl(globalData) {
    // if redirectUrl has value
    if (globalData.redirectUrl) {
        let mts = globalData.redirectUrl.match(/(?:\/\/([^/]+))?(\/[^?]+)/);
        if (
            mts &&
            ((mts[1] && mts[1] !== window.location.host) ||
                mts[2] !== window.location.pathname)
        ) {
            window.location = globalData.redirectUrl;
            return true;
        }
    }
}
const query = util.getQueryField();
initCookiesClient();
initCookies(util, query);

// CHIME-67459: 清 VOW sold-protected listing 的 sold/price 字段
// CHIME-67956: 来自合规审核页面时同样视为已验证，跳过清洗
const rawGlobalData = Object.assign({}, getGlobalData(), getOtherData());
const rawPageData = getPageData();
{
    const isVerified = isVowVerified({ vowListingsStatus: rawGlobalData?.loginInfo?.vowListingsStatus, isPopupQuery: query?.isPopup });
    if (Array.isArray(rawPageData?.modules)) {
        rawPageData.modules.forEach(mod => sanitizeVowSoldFields(mod?.data, isVerified));
    }
}

var { globalData, pageData } = handlerData({
    rawGlobalData,
    rawPageData,
    themeRootVar: generateThemeRootVar(),
    query
});

if (!checkRedirectUrl(globalData)) {
    // init custom code runner
    var runner = createRunner(globalData, pageData);
    runner.runCss();
    if (
        util.isReallyUser &&
        !util.inCmsPageEditor &&
        process.env.CHIME_ENV == 'production'
    ) {
        // rendebug load
        window.rendebug.setOn(Date.now() % 10 === 0);
    }
    // sitePrepareData method is ready
    window.sitePrepareData = function() {
        return globalData;
    };

    let platform = getPlatform(globalData);
    let lng = getCurrentLanguage.call(platform, globalData);
    let terminology = createTerminology(globalData.terminologyMap);
    let globalizationIns = globalization.create(
        lng,
        terminology && (content => terminology.replace(content))
    );
    window.siteGlobalization = globalizationIns;

    if (globalData.translatorType == 'chime') {
        googleTranslateAutoPage(lng, globalData);
    }

    window.$pinia = createPinia();
    let appConfig = getAppConfig();
    // console.log("appConfig",appConfig);
    var app = createApp(appConfig);
    let params = {
        pinia: window.$pinia,
        platform,
        globalData,
        pageData,
        globalizationIns
    };
    // global extension of vue
    plugin.install(app, params);
    getBodyPluginApp(params);
    window.siteAppVm = app.mount(getContainer(globalData.template));
    Router.multiPageInit(window.siteAppVm, globalData);

    //  execute sequence : cookie、[closely,chat]
    chat.aiConnect({ globalData }).finally(() => {
        util.asyncTaskSequenceExecutor([
            initCookieAuthority,
            () => Promise.all([chat.init({ globalData }), createDownloadPlugin()])
        ]);
    });
   

    //initRequirePhone(window.siteAppVm); // CHIME-64554
    // copyright
    initCopyRight(globalData);
    initGotoTop(globalData);
    initSidebar(globalData);
    // one-time pop-up
    handlePopup(globalData, pageData.moduleData);
    checkTimeoutSession(globalData.mlsOrgs);
    // run custom script
    runner.runScript();
    // other processing in client
    otherProcessing({ globalData, platform });

    // ga conversion
    gaConversion();
    // bing  Buried
    trackBingAd();
    // adwerx
    adwerx(globalData);
    fub(globalData);
    if (globalData.track?.enableGlobalGa && util.getQueryField('enable-gtm') != '0') {
        Track.prepare();
        Track.resetEventHandler();
    }
    Track.prepareCustomGTM();
    termOfUse(globalData);
    vowPassword.init(globalData);
    
}

// eslint-disable-next-line no-undef
console.log('__BUILD_ID__', __BUILD_ID__);
// eslint-disable-next-line no-undef
console.log('__chime env__', process.env.CHIME_ENV);

if (
    document.currentScript?.src &&
    typeof document.currentScript.src === 'string'
) {
    console.log(
        'CODE CDN :',
        document.currentScript.src.startsWith('https://static.chimeroi.com')
    );
}
document.addEventListener('click', e => {
    if (e.target.nodeName === 'A' && /tel:/.test(e.target.href)) {
        let target = e.target;
        target.href = (target.href || '').replaceAll(' ', '');
    }
});




// cms-ai 模块选择：?aiSelect=1 。
// 仅放行 localhost / *.lofty.com 来源，避免任意外链脚本注入。
console.log('query.aiSelect', query.aiSelect);
if (query.aiSelect == 1) {
    if (process.env.CHIME_ENV === "development") {
        util.addScript('http://localhost:8090/ai-select.js');
    } else {
        // from https://gitlab.d.chime.me/front-end/cms-ai/-/blob/main/server/src/ai-select/ai-select.js?
        // 脚本版本由 cms-ai 经 aiSelectSrc 参数指定，只接受 CDN 下的相对路径——域名前缀写死在这里
        // 不可被参数覆盖，且路径要过白名单校验（只允许 [字母数字 _-/.] 的 .js、不许 .. 与前导 /），
        // 因此无法被引导去加载任意外链脚本。这样 cms-ai 换脚本只需上传 CDN + 改自己的配置，不用再发 site 版。
        var AI_SELECT_CDN = 'https://static.chimeroi.com/';
        var AI_SELECT_DEFAULT = 'servicetool-temp/2026-8-6/8/0f2b6d43cac244a0_ai-select.js';
        var aiSelectSrc = query.aiSelectSrc || '';
        var aiSelectSafe =
            /^[A-Za-z0-9_\-/.]+\.js$/.test(aiSelectSrc) &&
            aiSelectSrc.indexOf('..') === -1 &&
            aiSelectSrc.charAt(0) !== '/';
        util.addScript(AI_SELECT_CDN + (aiSelectSafe ? aiSelectSrc : AI_SELECT_DEFAULT));
    }

}
